import { useCallback, useMemo } from "react";
import { useSession } from "hooks/useSession";
import {
  useLiveNotifications,
  type LiveNotification,
} from "../hooks/useLiveNotifications";
import { useMissingProjectTitles } from "../hooks/useMissingProjectTitles";
import { useOpenNotification } from "../hooks/useOpenNotification";
import { LiveNotificationsBell } from "./LiveNotificationsBell";

// No known titles here, so every notification's title is fetched.
const NO_KNOWN_TITLES: Record<string, string> = {};

export const OrganizationLiveNotifications = () => {
  const { currentOrganization } = useSession();
  const organizationId = currentOrganization?.id;

  const { notifications, unseenCount, markRead, markAllRead } =
    useLiveNotifications(organizationId);

  const notificationProjectIds = useMemo(
    () => notifications.map((n) => n.projectId),
    [notifications]
  );
  const notificationTitleById = useMissingProjectTitles(
    organizationId,
    notificationProjectIds,
    NO_KNOWN_TITLES
  );

  const { openNotification } = useOpenNotification();
  const handleOpenNotification = useCallback(
    (notification: LiveNotification) => {
      openNotification(notification);
      markRead(notification.id);
    },
    [markRead, openNotification]
  );

  return (
    <LiveNotificationsBell
      notifications={notifications}
      unseenCount={unseenCount}
      projectTitleById={notificationTitleById}
      onOpen={handleOpenNotification}
      onMarkAllRead={markAllRead}
    />
  );
};
